<template>
	<div class="itemWrapper">
		<div class="userInfor">
			<div class="avatarWrapper">
				<img :src="data.avatar" class="avatarImg img" />
			</div>
			<div class="userNameWrapper">
				<div class="userNameText">{{data.username}}</div>
				<div class="decorationText">学习了视频</div>
			</div>
			<div class="time"></div>
		</div>
		<div class="titleWrapper">
			<div class="title">{{data.title}}</div>
		</div>
		<div class="videoWrapper">
			<img :src="data.pic" alt="" class="img">
		</div>
		<div class="subItems">
			<div class="time">{{data.show_time}}</div>
			<div class="rightItems"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data']
}
</script>

<style scoped>
.itemWrapper{
	padding: 10px 15px;
	margin-top: 5px;
	background-color: #fff;
}
.userInfor{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 5px;
}
.avatarWrapper{
	width: 30px;
	height: 30px;
	overflow: hidden;
	border-radius: 15px;
	border-width: 1px;
	border-color: #fff;
}
.avatarImg{
	object-fit: cover;
}
.userNameWrapper{
	flex: 1;
	margin-left: 7px;
	margin-right: 7px;
}
.userNameText{
	font-size: 14px;
	color: #1d2023;
}
.decorationText{
	margin-top: 3px;
	font-size: 11px;
	color: #606972;
}
.titleWrapper{
	margin-bottom: 10px;
}
.title{
	flex: 1;
	font-size: 18px;
	font-weight: bold;
	color: #000;
}
.videoWrapper{
	height: 194px;
	margin-bottom: 10px;
	border-radius: 6px;
	overflow: hidden;
	background-color: #f7f8f8;
}
.videoWrapper > img{
	object-fit: cover;
}

.subItems{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.rightItems{
	display: flex;
}
.subitem{
	display: flex;
	align-items: center;
	padding-left: 4px;
	padding-right: 4px;
	font-size: 10px;
	color: #e60020;
	background-color: #fae7e7;
	border-radius: 2px;
}
.time{
	font-size: 12px;
	color: #606972;
}
.icon{
	display: inline-block;
	width: 15px;
	height: 15px;
	flex-shrink: 0;
	overflow: hidden;
}
.icon > img{
	object-fit: contain;
}
.hidden{
	display: none;
	width: 0;
	height: 0;
}
.img{
	width: 100%;
	height: 100%;
}
</style>